import React from 'react';

const AnalysisSummaryCard = ({ color, name, type, totalEmpreendimentos, ofertaLancada, ofertaFinal, unidadesVendidas, filtros, children }) => (
    <div className="info-card area-info ov-hidden" style={{ borderLeft: `4px solid ${color}` }}>
        <div className="info-card-header card-header" style={{ backgroundColor: color, color: '#fff', display: 'flex', alignItems: 'center' }}>
            <strong>{name || type || 'Área'}</strong>
        </div>
        <div className="card-body card-body-mapa-info">
            {/* Resumo dos filtros usados na busca (paridade com o InfoCard do mapa Google) */}
            {filtros?.length > 0 && (
                <div className="info-card-badges">
                    {filtros.map((filtro, key) => (
                        <span key={`${filtro}-${key}`} className="info-card-badge">
                            {filtro.length > 280 ? `${filtro.substring(0, 280)}…` : filtro}
                        </span>
                    ))}
                </div>
            )}
            <div className="mapbox-stat-grid">
                <div className="mapbox-stat">
                    <span className="mapbox-stat-label">Empreendimentos</span>
                    <span className="mapbox-stat-value">{totalEmpreendimentos}</span>
                </div>
                <div className="mapbox-stat">
                    <span className="mapbox-stat-label">Oferta lançada</span>
                    <span className="mapbox-stat-value">{ofertaLancada}</span>
                </div>
                <div className="mapbox-stat">
                    <span className="mapbox-stat-label">Oferta final</span>
                    <span className="mapbox-stat-value">{ofertaFinal}</span>
                </div>
                <div className="mapbox-stat">
                    <span className="mapbox-stat-label">Unidades vendidas</span>
                    <span className="mapbox-stat-value">{unidadesVendidas}</span>
                </div>
            </div>
        </div>
        {/* Rodapé do card (ex.: exports PDF/XLS + "Detalhar empreendimentos") */}
        {children && <div className="mapbox-card-footer">{children}</div>}
    </div>
);

export default AnalysisSummaryCard;
